import DefaultMainPage from "../../pages/DefaultMainPage";
import Event from "./Event";
import EventManager from "./EventManager";
import ShoppingRoadIndex from "./shoppingRoad/ShoppingRoadIndex";
import SegmentEvent from "./segment/SegmentEvent";
import EventSegment from "./segment/EventSegment";

const eventMenuItems = [
    {path: "/event/shoppingRoad", component: <ShoppingRoadIndex/>, label: '쇼핑로드'},
    {path: "/event", component: <Event/>, label: '이벤트'},
    {path: "/event/manager", component: <EventManager/>, label: '이벤트 매니저'},
    {path: "/event/segment", component: <SegmentEvent/>, label: '개인화 관리'},
    {path: "/event/segmentTable", component: <EventSegment/>, label: '개인화 테이블'},
];

export const eventRoutes = {
    path: "/event",
    component: <DefaultMainPage buttons={eventMenuItems}/>,
    children: eventMenuItems
}